import { motion } from "framer-motion";
import { CalendarClock, MessageCircle } from "lucide-react";
import { Reveal, MaskedHeading } from "./Reveal";
import { reservarElla, reservarEl, reservarDuo } from "../lib/booking";

const BookingCTA = () => {
  return (
    <section
      id="reserva"
      data-testid="section-cta"
      className="relative bg-[#1a1a1a] px-6 py-28 md:px-16 md:py-44 grain"
    >
      <div className="relative z-10 mx-auto max-w-4xl text-center">
        <Reveal>
          <span className="label text-[#b79b7d]">Reserva tu experiencia</span>
        </Reveal>
        <div className="mt-8">
          <MaskedHeading
            className="font-serif-display text-[#faf9f6] text-4xl sm:text-6xl lg:text-7xl leading-[1.02]"
            lines={["Tu momento", "empieza"]}
          />
          <MaskedHeading
            className="font-serif-display italic text-[#cea498] text-4xl sm:text-6xl lg:text-7xl leading-tight"
            lines={["aquí"]}
            delay={0.24}
          />
        </div>

        <Reveal delay={0.1} className="mx-auto mt-8 max-w-xl">
          <p className="text-sm md:text-base leading-relaxed text-[#cfc7c0]">
            Agenda tu experiencia de bienestar en línea de forma inmediata. Elige tu ritual, 
            selecciona tu profesional de preferencia y programa tu espacio en tiempo real. 
            Recibirás tu confirmación directamente por WhatsApp.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <motion.button
            data-testid="cta-reservar-ella"
            onClick={reservarElla}
            className="rounded-full bg-[#cea498] px-8 py-4 text-[#593d36] font-bold border border-[#593d36]/15"
            whileHover={{ backgroundColor: "#593d36", color: "#faf9f6" }}
          >
            <span className="label">Reservar para Ella</span>
          </motion.button>
          <motion.button
            data-testid="cta-reservar-el"
            onClick={reservarEl}
            className="rounded-full border border-[#b79b7d] px-8 py-4 text-[#faf9f6]"
            whileHover={{ backgroundColor: "#b79b7d", color: "#1a1a1a" }}
          >
            <span className="label">Reservar para Él</span>
          </motion.button>
          <motion.button
            data-testid="cta-reservar-duo"
            onClick={reservarDuo}
            className="rounded-full bg-transparent px-8 py-4 text-[#cea498] underline underline-offset-8"
            whileHover={{ color: "#f0e4e1" }}
          >
            <span className="label">Reservar DUO</span>
          </motion.button>
        </Reveal>

        <Reveal delay={0.2} className="mt-14 flex flex-wrap items-center justify-center gap-8 text-[#8c8078]">
          <span className="flex items-center gap-2 text-xs tracking-widest">
            <CalendarClock className="h-4 w-4 text-[#b79b7d]" /> Agenda en línea activa
          </span>
          <span className="flex items-center gap-2 text-xs tracking-widest">
            <MessageCircle className="h-4 w-4 text-[#b79b7d]" /> Confirmación por WhatsApp activa
          </span>
        </Reveal>
      </div>
    </section>
  );
};

export default BookingCTA;
